import { render, staticRenderFns } from "./SpoiledShowSettings.vue?vue&type=template&id=412dacfc&scoped=true&"
import script from "./SpoiledShowSettings.vue?vue&type=script&lang=js&"
export * from "./SpoiledShowSettings.vue?vue&type=script&lang=js&"
import style0 from "./SpoiledShowSettings.vue?vue&type=style&index=0&id=412dacfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412dacfc",
  null
  
)

export default component.exports